import { useMutation, useQuery } from '@tanstack/react-query';
import { useAgent } from '@/auth/use-agent';
import { fetchIssueOptions, fetchOverview, fetchPlayers, fetchResults, issueLink } from './limited-links';
import type { IssueLinkBody } from './types';

// Reports change when an agent issues or a player redeems; a minute of staleness is fine and
// keeps a click between pages from re-reading the warehouse.
const REPORT_STALE_MS = 60_000;

export function useOverview() {
  const { key } = useAgent();
  return useQuery({
    queryKey: ['overview', key],
    queryFn: ({ signal }) => fetchOverview(key, signal),
    staleTime: REPORT_STALE_MS,
  });
}

export function useIssueOptions() {
  const { key } = useAgent();
  return useQuery({
    queryKey: ['issue-options', key],
    queryFn: ({ signal }) => fetchIssueOptions(key, signal),
    staleTime: REPORT_STALE_MS,
  });
}

export function useResults(tournamentId: string) {
  const { key } = useAgent();
  return useQuery({
    queryKey: ['results', key, tournamentId],
    queryFn: ({ signal }) => fetchResults(key, tournamentId, signal),
    staleTime: REPORT_STALE_MS,
  });
}

export function usePlayers(tournamentId: string) {
  const { key } = useAgent();
  return useQuery({
    queryKey: ['players', key, tournamentId],
    queryFn: ({ signal }) => fetchPlayers(key, tournamentId, signal),
    staleTime: REPORT_STALE_MS,
  });
}

export function useIssueLink() {
  const { key } = useAgent();
  return useMutation({ mutationFn: (body: IssueLinkBody) => issueLink(key, body) });
}
